import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Rematrícula',
    path: '/academico/rematricula',
    name: 'rematricula',
    component: () => import('@/views/academico/rematricula/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.REMATRICULA_MENU_300200301],
    },
    goesToMenu: true,
  },
]
